import type { NotificationSettingsResponseDeliverySettings } from './notificationSettingsResponseDeliverySettings';
import type { NotificationSettingsResponseTypeSettings } from './notificationSettingsResponseTypeSettings';

/**
 * 알림 설정 응답 데이터
 */
export interface NotificationSettingsResponse {
  /** 알림 전달 설정 */
  deliverySettings?: NotificationSettingsResponseDeliverySettings;
  /** 알림 유형별 설정 */
  typeSettings?: NotificationSettingsResponseTypeSettings;
  /** 사용자 ID */
  userId: number;
}
